"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('send-one', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(4.000000, 6.000000)",
    stroke: props.outStrokeColor,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("polygon", {
    fill: props.outFillColor,
    fillRule: "nonzero",
    points: "38 -2.84217094e-14 0 14.1382599 20 18.0083363 25.005249 38"
  }), _react.default.createElement("path", {
    d: "M22.8391421,19.1799082 L22.8343802,11.1799082",
    strokeLinecap: props.strokeLinecap,
    transform: "translate(22.836761, 15.179908) rotate(45.034105) translate(-22.836761, -15.179908) "
  })))));
});

exports.default = _default;